import { useContext, useEffect, useState } from "react";
// import "./PanditBooking.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import DatePicker from "react-date-picker";
import Select from "react-select";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import {
  customSelectStyles,
  DurationLookupList,
  MonthDays,
  SelectLanguageOptions,
  WeekDays,
} from "../../middlewares/Utils";
import { GetPanditListDataAPI } from "../../ApiServices/PanditList/PanditList";
// import CODModal from "./CODModal";
import axios from "axios";
import {
  BaseUrl,
  GetPhonePayPaymentLink,
  RazorPayKey,
  RazorPayName,
  RazorPaySecretKey,
} from "../../BaseUrl/BaseUrl";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import "../Stepper Form/stepper.css";
import CODModalDailyBooking from "./CODModalDailyBooking";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { FaqModuleID, ServiceDiscounts } from "../../Components/enum";
import { LanguageList } from "../../ApiServices/DailyPanditAPI/DailyPanditApi";
import {
  CityLookupList,
  StateLookupList,
} from "../../ApiServices/Other/StateLookupListApi";
import { GetDurationDays } from "../../ApiServices/Other/DurationDaysApi";
import PhonePayCODModalDailyBooking from "./PhonePayCODModalDailyBooking";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { handleProceedRemainingPayment } from "../../Components/RazorPay/RazorPayFunction";
import { GetUserWalletAmount } from "../../ApiServices/UserWallet/UserWalletApi";
import CouponModal from "../../Components/CouponModal";

const steps = [
  "Daily Booking Details",
  // "Select Pandit",
  "Booking Preview",
  "Payment Status",
];

const DailyPujaBooking = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [languageOption, setLanguageOption] = useState([]);
  const [durationList, setDurationList] = useState([]);
  const [daysList, setDaysList] = useState([]);
  const [findPandit, setFindPandit] = useState(null);
  const [totalDays, setTotalDays] = useState(0);
  const [showCODModal, setShowCODModal] = useState(null);
  const [showPhonePayCODModal, setShowPhonePayCODModal] = useState(null);
  const [selectedPandit, setSelectedPandit] = useState(null);
  const [orderID, setOrderID] = useState();
  const [panditSelectionError, setPanditSelectionError] = useState(null);
  const [error, setError] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState(null);
  const [showBookingReviewModal, setShowBookingReviewModal] = useState(null);
  const [panditDataList, setPanditDataList] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedDuration, setSelectedDuration] = useState(null);
  const [selectedDays, setSelectedDays] = useState(null);

  const [stateLookupList, setStateLookupList] = useState([]);
  const [cityLookupList, setCityLookupList] = useState([]);
  const { setLoader } = useContext(LoaderContext);
  const [showModal, setShowModal] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState({
    CouponCode: null,
    isApplied: false,
    CoupenAmount: 0,
    walletAmount: 0,
    couponCodeID: null
  });
  const userID = localStorage.getItem("userID");
  const puja = location.state?.puja;
  const [isWalletApplied, setIsWalletApplied] = useState(false);
  const [couponObj, setCouponObj] = useState({
    userID: userID,
    serviceID: FaqModuleID?.DailyPujaBooking,
    subModuleID: [puja?.DP_ID],
    orderAmount: Math.round(puja.DP_PRICE)

  })
  const [couponAmount, setCouponAmount] = useState(0)
  const [walletAmount, setWalletAmount] = useState(0)

  const [productBookingData, setProductBookingData] = useState({
    startDate: null,
    endDate: null,
    startTime: null,
    endTime: null,
    languageID: null,
    landmark: null,
    address: null,
    pincode: null,
    city: null,
    state: null,
    needSamagri: "yes",
    needDrySamagri: 'yes',
    needWetSamagri: 'no',
  });
  const [modelRequestData, setModelRequestData] = useState({
    totalPrice: null,
    amountEntered: null,
    tax: null,
    convinienceFee: null,
    moduleName: null,
    couponCode: null
  });

  const fromDate = dayjs();


  console.log("puja", puja);
  console.log("productBookingData", productBookingData);

  const SGST = 9;
  const CGST = 9;

  // const tax = Math.round(
  //   ((SGST + CGST) / 100) * parseFloat(puja.CONVENIENCE_FEE)
  // );

  // let totalDays = null;

  useEffect(() => {

    if (isWalletApplied && appliedCoupon?.isApplied === false) {
      const minAmount = Math.min(((Number(puja.DP_PRICE) -
        (Number(puja.DP_PRICE) * Number(puja.DP_DISC)) /
        100)
        * totalDays), walletAmount);
      const discountAmount = Math.round(minAmount * 0.5);
      setAppliedCoupon((prev) => ({ ...prev, walletAmount: discountAmount }))
      setCouponAmount(discountAmount);
      // setCouponAmount(walletAmount)
    } else if (isWalletApplied === false && appliedCoupon?.isApplied === true) {
      setCouponAmount(appliedCoupon?.CoupenAmount)
    } else {
      setCouponAmount(0)
    }
  }, [isWalletApplied, appliedCoupon])

  useEffect(() => {

    if (isWalletApplied && appliedCoupon?.isApplied === false) {
      const minAmount = Math.min(puja.DP_PRICE, walletAmount);
      const discountAmount = minAmount * 0.5;
      setCouponAmount(discountAmount);
      // setCouponAmount(walletAmount)
    } else if (isWalletApplied === false && appliedCoupon?.isApplied === true) {
      setCouponAmount(appliedCoupon?.CoupenAmount)
    } else {
      setCouponAmount(0)
    }
  }, [isWalletApplied, appliedCoupon])

  const [razorPayData, setRazorPayData] = useState({
    PB_DATE: null,
    PB_TIME: null,
    PB_LANGAUGE: null,
    PB_SAMAGRI: null,
    PB_PRICE: null,
    PB_SAMAGRIPRICE: null,
    PANDIT_ID: null,
    USER_ID: null,
    REFERENCES_NO: "",
    ADDRESS: null,
    PUJA_ID: null,
    PAYMENT_TYPE: null,
    CONVINIENCE_FEE: null,
    TAX: null,
    EXTRA: null,
    TRANSACTION_ID: "",
    TRANSACTION_AMT: "",
  });

  // console.log("razorPayData", location.state);
  const basePrice = Math.round(
    Number(puja.DP_PRICE) -
    (Number(puja.DP_PRICE) * Number(puja.DP_DISC)) / 100
  );

  let samagriPrice = 0;
  if (productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "yes") {
    samagriPrice = samagriPrice + ((Number(puja?.WetSamagriPrice) +
      Number(puja?.WetSamagriPriceTaxAmount)) + (Number(puja?.DrySamagriprice) +
        Number(puja?.DrySamagriPriceTaxAmount)))
  } else if (productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "no") {
    samagriPrice = samagriPrice + (Number(puja?.WetSamagriPrice) +
      Number(puja?.WetSamagriPriceTaxAmount))
  } else if (productBookingData?.needWetSamagri === "no" && productBookingData?.needDrySamagri === "yes") {
    samagriPrice = samagriPrice + (Number(puja?.DrySamagriprice) +
      Number(puja?.DrySamagriPriceTaxAmount))
  }

  const convinienceFee = Math.round(Number(puja?.CONVENIENCE_FEE || 0) +
    Number(puja?.ConvinienceFeeTaxAmount || 0))



  const totalPrice = basePrice + samagriPrice + convinienceFee;
  // const totalPrice =
  //   Math.round(
  //     Number(puja.DP_PRICE) -
  //     (Number(puja.DP_PRICE) * Number(puja.DP_DISC)) / 100
  //   ) + productBookingData.needSamagri === "yes" &&
  //   (Number(puja?.DP_SAMAGRI_PRICE) + Number(puja?.SamagriPriceTaxAmount)) +
  //   parseFloat(puja?.CONVENIENCE_FEE) +
  //   parseFloat(puja?.ConvinienceFeeTaxAmount)


  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      if (currentStep === 0) {
        setCurrentStep(1); // Move to "Booking Preview"
      } else {
        setCurrentStep(currentStep + 1);
      }
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      if (currentStep === 2) {
        setAppliedCoupon((prev) => ({
          ...prev, CouponCode: null,
          isApplied: false,
          CoupenAmount: 0,
          walletAmount: 0
        }))
        setIsWalletApplied(false)
        setCurrentStep(1); // Move back to "Booking Preview"
      } else {
        setAppliedCoupon((prev) => ({
          ...prev, CouponCode: null,
          isApplied: false,
          CoupenAmount: 0,
          walletAmount: 0
        }))
        setIsWalletApplied(!isWalletApplied)
        setCurrentStep(currentStep - 1);
      }
    }
  };

  const tax = Math.round(
    (ServiceDiscounts.DailyBookingDiscount / 100) * Number(totalPrice)
  );

  const grandTotal = Math.round(parseFloat((totalPrice * totalDays) - couponAmount || 0));

  useEffect(() => {
    GetPanditListData();
  }, [productBookingData?.languageID]);
  useEffect(() => {
    GetLanguageListLookupListData();
    GetDurationListLookupListData();
    GetStateLookupListData();
    GetUserWalletAmountData()
  }, []);

  useEffect(() => {
    if (
      productBookingData?.state !== null &&
      productBookingData?.state !== undefined &&
      productBookingData?.state !== ""
    ) {
      GetCityLookupListData(productBookingData?.state);
    }
  }, [productBookingData?.state]);

  useEffect(() => {
    if (
      selectedDuration !== null &&
      selectedDuration !== undefined &&
      selectedDuration !== ""
    ) {
      console.log("selectedDuration", selectedDuration);
      GetDaysLookupListData();
    }
  }, [selectedDuration]);

  useEffect(() => {
    let calculatedDays = 0;

    if (selectedDuration === 1) {
      calculatedDays = selectedDays * 7;
    } else if (selectedDuration === 2) {
      calculatedDays = selectedDays * 30;
    }

    if (calculatedDays > 0 && productBookingData?.startDate) {
      const startDate = new Date(productBookingData.startDate); // Ensure it's a Date object
      if (!isNaN(startDate)) {
        // Check if the conversion was successful
        const newEndDate = new Date(startDate);
        newEndDate.setDate(startDate.getDate() + calculatedDays - 1);

        setProductBookingData((prev) => ({
          ...prev,
          endDate: newEndDate.toISOString().split("T")[0], // Format as YYYY-MM-DD if needed
        }));
      } else {
        console.error("Invalid startDate:", productBookingData.startDate);
      }
    }
  }, [selectedDays, selectedDuration, productBookingData?.startDate]);


  const GetUserWalletAmountData = async () => {

    setLoader(true);
    try {
      let response = await GetUserWalletAmount(userID); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);
        const list = response?.DATA || [];
        setWalletAmount(Number(list[0]?.WalletAmount) <= 0 ? 0 : list[0]?.WalletAmount)
      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  //   useEffect(() => {
  //     debugger;
  //     setRazorPayData((prev) => ({
  //       ...prev,
  //       PB_DATE: productBookingData.date,
  //       PB_TIME: productBookingData.time,
  //       PB_LANGAUGE: SelectLanguageOptions.find(
  //         (item) => item.value === productBookingData.languageID
  //       )?.label,
  //       PB_SAMAGRI: productBookingData.needSamagri,
  //       PB_PRICE: productBookingData?.pujaPrice,
  //       PB_SAMAGRIPRICE: productBookingData?.pujaSamagriPrice,
  //       PANDIT_ID: selectedPandit,
  //       USER_ID: userID,
  //       REFERENCES_NO: "",
  //       ADDRESS: productBookingData?.address,
  //       PUJA_ID: productBookingData?.pujaId,
  //       PAYMENT_TYPE: "ONLINE",
  //       CONVINIENCE_FEE: productBookingData?.convenienceFee,
  //       TAX: null,
  //       EXTRA: null,
  //       TRANSACTION_ID: "",
  //       TRANSACTION_AMT: "",
  //     }));
  //   }, []);

  //   const GetPanditListData = () => {};
  const GetPanditListData = async () => {
    // debugger;
    try {
      const response = await GetPanditListDataAPI(
        userID,
        puja.DP_ID,
        productBookingData?.languageID,
        {
          START: 1,
          END: 10,
          WORD: "None",
          LATITUDE: "20.0086678",
          LONGITUDE: "73.7639264",
        }
      );

      if (response) {
        setPanditDataList(response.DATA);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const HandleProductBookingBtnClicked = () => {
    // debugger;
    let isValid = false;

    if (
      productBookingData.startDate === null ||
      productBookingData.startDate === undefined ||
      productBookingData.startDate === "" ||
      productBookingData.endDate === null ||
      productBookingData.endDate === undefined ||
      productBookingData.endDate === "" ||
      productBookingData.startTime === null ||
      productBookingData.startTime === undefined ||
      productBookingData.startTime === "" ||
      productBookingData.endTime === null ||
      productBookingData.endTime === undefined ||
      productBookingData.endTime === "" ||
      productBookingData.landmark === null ||
      productBookingData.landmark === undefined ||
      productBookingData.landmark === "" ||
      productBookingData.languageID === null ||
      productBookingData.languageID === undefined ||
      productBookingData.languageID === "" ||
      productBookingData.address === null ||
      productBookingData.address === undefined ||
      productBookingData.address === "" ||
      productBookingData.state === null ||
      productBookingData.state === undefined ||
      productBookingData.state === "" ||
      productBookingData.city === null ||
      productBookingData.city === undefined ||
      productBookingData.city === "" ||
      productBookingData.pincode === null ||
      productBookingData.pincode === undefined ||
      productBookingData.pincode === "" ||
      productBookingData.needSamagri === null ||
      productBookingData.needSamagri === undefined ||
      productBookingData.needSamagri === ""
    ) {
      isValid = true;
      setError(true);
    }

    // const api_Params = {
    //   date: productBookingData.date,
    //   time: productBookingData.time,
    //   languageID: productBookingData.languageID,
    //   landmark: productBookingData.landmark,
    //   address: productBookingData.address,
    //   pincode: productBookingData.pincode,
    //   city: productBookingData.city,
    //   state: productBookingData.state,
    //   needSamagri: productBookingData.needSamagri,
    // };

    if (!isValid) {
      //   navigate("/services/book-puja/puja-details/pandit-list", {
      //     state: { productBookingData: productBookingData, product: product },
      //   });
      handleFindPandit();
      // nextStep();
    }
  };

  const handleRazorpayPayment = async () => {
    // let totalAmount = parseInt(modelRequestData.totalVal); // Assuming totalVal includes shipping
    let minPayableAmount = modelRequestData.amountEntered
      ? Math.round(modelRequestData.amountEntered)
      : Number(grandTotal);

    let orderIDReturned = null;
    const PlaceOrderResponse = await handleProceedRemainingPayment(minPayableAmount)
    console.log('PlaceOrderResponse', PlaceOrderResponse)
    setLoader(true)
    if (PlaceOrderResponse?.status === 1) {
      setLoader(true);
      axios
        .post(`${BaseUrl}/DailyPujaBook`, {
          DPB_FROMDATE: productBookingData?.startDate,
          DPB_TODATE: productBookingData?.endDate,
          DPB_FROMTIME: productBookingData?.startTime,
          DPB_TOTIME: productBookingData?.endTime,
          DPB_LANGAUGE: SelectLanguageOptions.find(
            (item) => item.value === productBookingData?.languageID
          )?.value,
          DPB_SAMAGRI: puja.DP_SAMAGRI,
          NEED_SAMAGRI: productBookingData.needSamagri,
          DPB_PRICE: Number(puja?.DP_PRICE) * totalDays,
          DPB_SAMAGRIPRICE: productBookingData.needSamagri === 'yes' ? Number(puja?.DP_SAMAGRI_PRICE) * totalDays : 0,
          PANDIT_ID: findPandit === true ? null : selectedPandit,
          USER_ID: userID,
          REFERENCES_NO: "",
          ADDRESS: productBookingData?.address,
          DP_ID: puja?.DP_ID,
          PAYMENT_TYPE: modelRequestData.amountEntered ? "COD" : "ONLINE",
          CONVENIENCE_FEE: Number(puja?.CONVENIENCE_FEE) * totalDays,
          TAX: Number(tax),
          EXTRA: null,
          // TRANSACTION_ID: ,
          TRANSACTION_AMT: Number(minPayableAmount),
          DPB_DiscountPercentage: puja.DP_DISC,
          DPB_DiscountAmount: Number(puja.DiscountAmount) * totalDays || 0,
          DPB_Total: Number(puja.DP_PRICE),
          DPB_TaxPercentage: 22,
          DPB_TaxAmount: tax,
          DPB_GrandTotal: grandTotal,
          PAYMENT_STATUS:
            minPayableAmount === grandTotal ? "Completed" : "Pending",
          TRANSACTION_STATUS: "Success",
          SamagriPriceTaxAmount: puja?.SamagriPriceTaxAmount * totalDays,
          SamagriPriceTaxPercent: puja?.SamagriPriceTaxPercent,
          ConvinienceFeeTaxPercent: puja?.ConvinienceFeeTaxPercent,
          ConvinienceFeeTaxAmount: puja?.ConvinienceFeeTaxAmount * totalDays,
          CouponCodeID: appliedCoupon?.couponCodeID,
          CouponCodeAmount: appliedCoupon?.CoupenAmount,
          WalletAmount: appliedCoupon?.walletAmount,
          DrySamagriprice: productBookingData?.needDrySamagri === 'yes' ? Number(puja?.DrySamagriprice) * totalDays : 0,
          WetSamagriPrice: productBookingData?.needWetSamagri === 'yes' ? Number(puja?.WetSamagriPrice) * totalDays : 0,
          WetSamagriPriceTaxPercent: puja?.WetSamagriPriceTaxPercent,
          DrySamagriPriceTaxPercent: puja?.DrySamagriPriceTaxPercent,
          NeedDrySamagri: productBookingData?.needDrySamagri,
          NeedWetSamagri: productBookingData?.needWetSamagri,
          DrySamagriPriceTaxAmount: Number(puja?.DrySamagriPriceTaxAmount) * totalDays,
          WetSamagriPriceTaxAmount: Number(puja?.WetSamagriPriceTaxAmount) * totalDays
        })
        .then((res) => {
          if (res) {
            console.log(res);
            setOrderID(res.data.ID);

            setShowCODModal(false);
            orderIDReturned = res.data.ID;
            setLoader(false);
            navigate("/thank-you", {
              state: { moduleName: "DailyPujaBooking" },
            });
            // nextStep();
          }
        });
    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false)
      alert('Order Failed !')
    }

  }

  console.log(puja?.DP_PRICE * totalDays, "puja?.DP_PRICE * totalDays");
  // const BookPujaAPI = async () => {
  //   debugger;
  //   axios
  //     .post(`${BaseUrl}/BookPooja`, {
  //       PB_DATE: productBookingData.date,
  //       PB_TIME: productBookingData.time,
  //       PB_LANGAUGE: SelectLanguageOptions.find(
  //         (item) => item.value === productBookingData.languageID
  //       )?.label,
  //       PB_SAMAGRI: productBookingData.needSamagri,
  //       PB_PRICE: productBookingData?.pujaPrice,
  //       PB_SAMAGRIPRICE: productBookingData?.pujaSamagriPrice,
  //       PANDIT_ID: selectedPandit,
  //       USER_ID: userID,
  //       REFERENCES_NO: "",
  //       ADDRESS: productBookingData?.address,
  //       PUJA_ID: productBookingData?.pujaId,
  //       PAYMENT_TYPE: "ONLINE",
  //       CONVINIENCE_FEE: productBookingData?.convenienceFee,
  //       TAX: null,
  //       EXTRA: null,
  //       TRANSACTION_ID: "",
  //       TRANSACTION_AMT: "",
  //     })
  //     .then((res) => {
  //       if (res) {
  //         console.log(res);
  //         setOrderID(res.data.ID);
  //         localStorage.setItem("orderID", JSON.stringify(res.data.ID));
  //         orderIDReturned = res.data.ID;
  //       }
  //     });
  // };

  const handlePanditSelectionNext = () => {
    // debugger;
    if (
      selectedPandit !== null &&
      selectedPandit !== undefined &&
      selectedPandit !== ""
    ) {
      // console.log("Panditselection");
      nextStep();
    } else {
      setPanditSelectionError(true);
    }
  };

  const handleStartDateChange = (newValue) => {
    if (dayjs(newValue).isValid()) {
      const newToDate = dayjs(newValue).format("YYYY-MM-DD");
      setProductBookingData((prev) => ({ ...prev, startDate: newToDate }));
    } else {
      setProductBookingData((prev) => ({ ...prev, startDate: null }));
    }
  };

  const handleEndDateChange = (newValue) => {
    if (dayjs(newValue).isValid()) {
      const newToDate = dayjs(newValue).format("YYYY-MM-DD");
      setProductBookingData((prev) => ({ ...prev, endDate: newToDate }));
    } else {
      setProductBookingData((prev) => ({ ...prev, endDate: null }));
    }
  };

  const handleLanguageChange = (selectedValue) => {
    setProductBookingData((prev) => ({
      ...prev,
      languageID: selectedValue.value,
    }));
  };
  const handleDurationChange = (selectedValue) => {
    setSelectedDuration(selectedValue.value);
  };
  const handleDaysChange = (selectedValue) => {
    setSelectedDays(selectedValue.value);
    setTotalDays(selectedValue?.totalDays);
  };

  const handlePanditCardClicked = (pandit) => {
    setSelectedPandit(pandit.PANDIT_ID);
    // console.log(pandit);
  };

  const handlePhonePayCODClicked = () => {
    setModelRequestData((prev) => ({
      ...prev,
      totalPrice: grandTotal,
      tax: tax,
      convinienceFee: Math.round(Number(puja.CONVENIENCE_FEE)) * totalDays,
      convenienceFeeFax:
        Math.round(Number(puja?.ConvinienceFeeTaxAmount)) * totalDays,
      SamagriPriceTaxAmount:
        puja.SamagriPriceTaxAmount != 0
          ? Math.round(Number(puja?.SamagriPriceTaxAmount)) * totalDays
          : 0,
    }));
    setShowPhonePayCODModal(true);
  };
  const handleCODClicked = () => {
    setModelRequestData((prev) => ({
      ...prev,
      totalPrice: grandTotal,
      tax: tax,
      convinienceFee: Math.round(Number(puja.CONVENIENCE_FEE)) * totalDays,
      convenienceFeeFax:
        Math.round(Number(puja?.ConvinienceFeeTaxAmount)) * totalDays,
      SamagriPriceTaxAmount:
        puja.SamagriPriceTaxAmount != 0
          ? Math.round(Number(puja?.SamagriPriceTaxAmount)) * totalDays
          : 0,
    }));
    setShowCODModal(true);
  };

  const handleFindPandit = () => {
    setFindPandit(true);
    nextStep();
  };

  console.log(totalPrice);

  const renderStarRating = (rating) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      if (i < Math.floor(rating)) {
        stars.push(<i key={i} className="fa fa-star filled-star"></i>); // Full Star
      } else if (i < rating) {
        stars.push(<i key={i} className="fa fa-star-half-alt half-star"></i>); // Half Star
      } else {
        stars.push(<i key={i} className="fa fa-star empty-star"></i>); // Empty Star
      }
    }
    return stars;
  };

  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount.toString().split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }

  const formatTime = (timeString) => {
    if (!timeString) return "";
    const [hours, minutes] = timeString.split(":"); // Assuming time is in "HH:mm" format
    const date = new Date();
    date.setHours(hours, minutes);

    return date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };
  console.log("totalDays", totalDays);

  const GetStateLookupListData = async () => {
    try {
      const response = await StateLookupList(1); // Ensure it's correctly imported

      if (response?.ResponseCode === "0") {
        const languageLookupList = response?.DATA || [];

        const formattedLangList = languageLookupList.map((Lang) => ({
          value: Lang.StateID,
          label: Lang.StateName,
        }));

        setStateLookupList(formattedLangList);
      } else {
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error fetching sim Type lookup list:", error);
    }
  };
  const GetCityLookupListData = async (ID) => {
    try {
      const response = await CityLookupList(ID); // Ensure it's correctly imported

      if (response?.ResponseCode === "0") {
        const languageLookupList = response?.DATA || [];

        const formattedLangList = languageLookupList.map((Lang) => ({
          value: Lang.DistrictID,
          label: Lang.DistrictName,
        }));

        setCityLookupList(formattedLangList);
      } else {
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error fetching sim Type lookup list:", error);
    }
  };

  const GetLanguageListLookupListData = async () => {
    try {
      const response = await LanguageList(); // Ensure it's correctly imported

      if (response?.ResponseCode === "0") {
        const languageLookupList = response?.DATA || [];

        const formattedLangList = languageLookupList.map((Lang) => ({
          value: Lang.LANG_ID,
          label: Lang.LANG_NAME,
        }));

        setLanguageOption(formattedLangList);
      } else {
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error fetching sim Type lookup list:", error);
    }
  };
  const GetDurationListLookupListData = async () => {
    try {
      // const response = await LanguageList(); // Ensure it's correctly imported
      const response = DurationLookupList;

      if (response?.ResponseCode === "0" || response !== null) {
        // const languageLookupList = response?.DATA || [];
        setDurationList(response);
        // const formattedLangList = languageLookupList.map((Lang) => ({
        //   value: Lang.LANG_ID,
        //   label: Lang.LANG_NAME,
        // }));

        // setLanguageOption(formattedLangList);
      } else {
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error fetching sim Type lookup list:", error);
    }
  };
  const GetDaysLookupListData = async () => {
    try {
      const response = await GetDurationDays(selectedDuration); // Ensure it's correctly imported
      // const response = selectedDuration === 1 ? WeekDays : MonthDays

      if (response?.ResponseCode === "0") {
        const languageLookupList = response?.DATA || [];

        const formattedLangList = languageLookupList.map((Lang) => ({
          value: Lang.Days,
          label: Lang.Days,
          totalDays: Lang.TotalDays,
        }));
        setDaysList(formattedLangList);
        // setLanguageOption(formattedLangList);
      } else {
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error fetching sim Type lookup list:", error);
    }
  };
  const handlePhonepayPayment = () => {
    let minPayableAmount = modelRequestData.amountEntered
      ? Math.round(modelRequestData.amountEntered)
      : Number(grandTotal);

    const PhonePayOption = {
      UserID: userID,
      MobileNumber: "",
      ModalName: "dailyPujaBooking",
      Amount: Math.round(minPayableAmount),
    };

    const dailyPoojaBookingData = {
      DPB_FROMDATE: productBookingData?.startDate,
      DPB_TODATE: productBookingData?.endDate,
      DPB_FROMTIME: productBookingData?.startTime,
      DPB_TOTIME: productBookingData?.endTime,
      DPB_LANGAUGE: SelectLanguageOptions.find(
        (item) => item.value === productBookingData?.languageID
      )?.value,
      DPB_SAMAGRI: puja.DP_SAMAGRI,
      NEED_SAMAGRI: productBookingData.needSamagri,
      DPB_PRICE: Number(puja?.DP_PRICE) * totalDays,
      DPB_SAMAGRIPRICE: Number(puja?.DP_SAMAGRI_PRICE) * totalDays,
      PANDIT_ID: findPandit === true ? null : selectedPandit,
      USER_ID: userID,
      REFERENCES_NO: "",
      ADDRESS: productBookingData?.address,
      DP_ID: puja?.DP_ID,
      PAYMENT_TYPE: modelRequestData.amountEntered ? "COD" : "ONLINE",
      CONVENIENCE_FEE: Number(puja?.CONVENIENCE_FEE) * totalDays,
      TAX: Number(tax),
      EXTRA: null,
      // TRANSACTION_ID: paymentId,
      TRANSACTION_AMT: Number(minPayableAmount),
      DPB_DiscountPercentage: puja.DP_DISC,
      DPB_DiscountAmount: Number(puja.DiscountAmount) * totalDays || 0,
      DPB_Total: Number(puja.DP_PRICE),
      DPB_TaxPercentage: 22,
      DPB_TaxAmount: tax,
      DPB_GrandTotal: grandTotal,
      PAYMENT_STATUS: minPayableAmount === grandTotal ? "Completed" : "Pending",
      TRANSACTION_STATUS: "Success",
      SamagriPriceTaxAmount: puja?.SamagriPriceTaxAmount,
      SamagriPriceTaxPercent: puja?.SamagriPriceTaxPercent,
      ConvinienceFeeTaxPercent: puja?.ConvinienceFeeTaxPercent,
      ConvinienceFeeTaxAmount: puja?.ConvinienceFeeTaxAmount,
    };

    axios
      .post(`${BaseUrl}/${GetPhonePayPaymentLink}`, PhonePayOption)
      .then((res) => {
        if (res?.data?.success) {
          console.log("PhonePe Response:", res.data);

          // Use navigate with state instead of window.location.href
          localStorage.setItem(
            "dailyPujaBookingData",
            JSON.stringify(dailyPoojaBookingData)
          );

          window.location.href = res.data.redirectUrl;
        } else {
          console.error("PhonePe Payment Failed:", res.data);
          alert("Something went wrong while creating the payment link.");
        }
      })
      .catch((error) => {
        console.error("PhonePe API Error:", error);
        alert("Failed to initiate PhonePe payment. Please try again.");
      });
  };

  const handleOpenCoupenModal = () => {

    setModelRequestData((prev) => ({ ...prev, moduleName: 'PujaBooking' }))
    setShowModal(true)
  }
  console.log('puja', puja)
  return (
    <div style={{ background: "#F1F6F7", paddingTop: "30px" }}>
      {/* Step Indicator */}
      <div className="stepper-wrapper">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`stepper-item ${index < currentStep
              ? "completed"
              : index === currentStep
                ? "active"
                : ""
              }`}
          >
            <div className="step-counter">{index + 1}</div>
            <div className="step-name" style={{ fontSize: "small" }}>
              {step}
            </div>
          </div>
        ))}
      </div>

      {/* Step Content */}
      <div
        className="step-content"
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "10px 30px",
          background: "#F1F6F7",
        }}
      >
        {currentStep === 0 && (
          <>
            <div className="booking-details-container ">
              <div
                className="booking-details-left"
              // style={{
              //   padding: "10px 20px",
              //   display: "flex",
              //   alignItems: "center",
              //   justifyContent: "center",
              // }}
              >
                <h5>Booking Details</h5>
                <hr />
                <div className="row">
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label
                      htmlFor="bookingDateStart"
                      style={{ textAlign: "left" }}
                    >
                      Start Date<span style={{ color: "red" }}>*</span>
                    </label>
                    <DatePicker
                      id="bookingDateStart"
                      value={productBookingData?.startDate || ""}
                      minDate={
                        new Date(new Date().setDate(new Date().getDate() + 3))
                      }
                      clearIcon={null}
                      onChange={handleStartDateChange}
                      format="dd/MM/yyyy"
                      className="custom-date-picker"
                    />

                    {error && !productBookingData.startDate && (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    )}
                  </div>
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label htmlFor="language" style={{ textAlign: "left" }}>
                      Select Duration<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      styles={customSelectStyles}
                      options={durationList}
                      onChange={handleDurationChange}
                      value={durationList.find(
                        (item) => item.value === selectedDuration
                      )}
                    />
                    {error && !selectedDuration && (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    )}
                  </div>
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label htmlFor="language" style={{ textAlign: "left" }}>
                      Select Days<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      styles={customSelectStyles}
                      options={daysList}
                      onChange={handleDaysChange}
                      value={daysList.find(
                        (item) => item.value === selectedDays
                      )}
                    />
                    {error && !selectedDays && (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    )}
                  </div>
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label
                      htmlFor="bookingDateEnd"
                      style={{ textAlign: "left" }}
                    >
                      End Date<span style={{ color: "red" }}>*</span>
                    </label>
                    <DatePicker
                      id="bookingDateEnd"
                      disabled
                      value={productBookingData?.endDate || ""}
                      minDate={
                        new Date(new Date().setDate(new Date().getDate() + 3))
                      }
                      clearIcon={null}
                      onChange={handleEndDateChange}
                      format="dd/MM/yyyy"
                      className="custom-date-picker"
                    />

                    {error && !productBookingData.endDate && (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    )}
                    {/* {error && !productBookingData.time && (
                      <span className="error-msg">{ERROR_MESSAGES}</span>
                    )} */}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label htmlFor="bookingTime" style={{ textAlign: "left" }}>
                      Start Time<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      id="bookingTime"
                      type="time"
                      className="custom-form-control"
                      onClick={(e) =>
                        e.target.showPicker && e.target.showPicker()
                      }
                      value={productBookingData.startTime || ""}
                      onChange={(e) =>
                        setProductBookingData((prev) => ({
                          ...prev,
                          startTime: e.target.value,
                        }))
                      }
                    />
                    {error && !productBookingData.startTime && (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    )}
                  </div>{" "}
                  {/* State */}
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label htmlFor="bookingTime" style={{ textAlign: "left" }}>
                      End Time<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      id="bookingTime"
                      type="time"
                      onClick={(e) =>
                        e.target.showPicker && e.target.showPicker()
                      }
                      className="custom-form-control"
                      value={productBookingData.endTime || ""}
                      onChange={(e) =>
                        setProductBookingData((prev) => ({
                          ...prev,
                          endTime: e.target.value,
                        }))
                      }
                    />
                    {error && !productBookingData.endTime && (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    )}
                  </div>
                </div>

                <div className="row">
                  {" "}
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label htmlFor="language" style={{ textAlign: "left" }}>
                      Select Language<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      styles={customSelectStyles}
                      options={languageOption}
                      onChange={handleLanguageChange}
                      value={languageOption.find(
                        (item) => item.value === productBookingData.languageID
                      )}
                    />
                    {error && !productBookingData.languageID && (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    )}
                  </div>{" "}
                  {/* Landmark */}
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label htmlFor="landmark" style={{ textAlign: "left" }}>
                      Landmark<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      id="landmark"
                      type="text"
                      className="custom-form-control"
                      value={productBookingData.landmark || ""}
                      onChange={(e) => {
                        let inputVal = e.target.value.trimStart();
                        setProductBookingData((prev) => ({
                          ...prev,
                          landmark: inputVal,
                        }));
                      }}
                      placeholder="Enter Landmark"
                    />
                    {error && !productBookingData.landmark && (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    )}
                  </div>
                </div>

                <div className="row">
                  {/* Address */}
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label htmlFor="address" style={{ textAlign: "left" }}>
                      Address<span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      id="address"
                      className="custom-form-control"
                      value={productBookingData.address || ""}
                      onChange={(e) => {
                        let inputVal = e.target.value.trimStart();
                        setProductBookingData((prev) => ({
                          ...prev,
                          address: inputVal,
                        }));
                      }}
                      placeholder="Enter Address"
                    />
                    {error && !productBookingData.address && (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    )}
                  </div>

                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label htmlFor="state" style={{ textAlign: "left" }}>
                      State<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      styles={customSelectStyles}
                      options={stateLookupList}
                      value={stateLookupList.find(
                        (item) => item.value === productBookingData.state
                      )}
                      onChange={(selectedOption) => {
                        setProductBookingData((prev) => ({
                          ...prev,
                          state: selectedOption?.value,
                        }));
                      }}
                    />

                    {error && !productBookingData.state && (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label htmlFor="City" style={{ textAlign: "left" }}>
                      City
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      styles={customSelectStyles}
                      options={cityLookupList}
                      value={cityLookupList.find(
                        (item) => item.value === productBookingData.city
                      )}
                      onChange={(selectedOption) => {
                        setProductBookingData((prev) => ({
                          ...prev,
                          city: selectedOption?.value,
                        }));
                      }}
                    />
                    {error &&
                      (productBookingData.city === null ||
                        productBookingData.city === undefined ||
                        productBookingData.city === "") ? (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    ) : (
                      ""
                    )}
                  </div>{" "}
                  <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                    <label htmlFor="pincode" style={{ textAlign: "left" }}>
                      Pincode
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      id="pincode"
                      type="text"
                      maxLength={6}
                      className="custom-form-control"
                      value={productBookingData.pincode || ""}
                      onChange={(e) => {
                        let inputVal = e.target.value;

                        // Remove any non-numeric characters
                        inputVal = inputVal.replace(/\D/g, "");

                        setProductBookingData((prev) => ({
                          ...prev,
                          pincode: inputVal,
                        }));
                      }}
                      placeholder="Enter Pincode"
                    //   style={{ padding: "0px" }}
                    />
                    {error &&
                      (productBookingData.pincode === null ||
                        productBookingData.pincode === undefined ||
                        productBookingData.pincode === "") ? (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div>
                  Do you want Samagri for this Puja?
                </div>
                <div className="row mb-3">
                  {/* Wet Samagri */}
                  {Number(puja?.WetSamagriPrice) > 0 && (
                    <div className="col-md-6 col-sm-12 d-flex align-items-center">
                      <label className="fw-semibold me-2 mb-0">Wet Samagri:</label>
                      <div className="d-flex align-items-center">
                        <label className="me-3 mb-0">
                          <input
                            type="radio"
                            name="wetSamagri"
                            value="yes"
                            checked={productBookingData.needWetSamagri === "yes"}
                            onChange={(e) =>
                              setProductBookingData((prev) => ({
                                ...prev,
                                needWetSamagri: e.target.value,
                              }))
                            }
                            className="me-1"
                          />
                          Yes
                        </label>
                        <label className="mb-0">
                          <input
                            type="radio"
                            name="wetSamagri"
                            value="no"
                            checked={productBookingData.needWetSamagri === "no"}
                            onChange={(e) =>
                              setProductBookingData((prev) => ({
                                ...prev,
                                needWetSamagri: e.target.value,
                              }))
                            }
                            className="me-1"
                          />
                          No
                        </label>
                      </div>
                    </div>
                  )}


                  {/* Dry Samagri */}
                  {Number(puja?.DrySamagriprice) > 0 && (
                    <div className="col-md-6 col-sm-12 d-flex align-items-center">
                      <label className="fw-semibold me-2 mb-0">Dry Samagri:</label>
                      <div className="d-flex align-items-center">
                        <label className="me-3 mb-0">
                          <input
                            type="radio"
                            name="drySamagri"
                            value="yes"
                            checked={productBookingData?.needDrySamagri === "yes"}
                            onChange={(e) =>
                              setProductBookingData((prev) => ({
                                ...prev,
                                needDrySamagri: e.target.value,
                              }))
                            }
                            className="me-1"
                          />
                          Yes
                        </label>
                        <label className="mb-0">
                          <input
                            type="radio"
                            name="drySamagri"
                            value="no"
                            checked={productBookingData.needDrySamagri === "no"}
                            onChange={(e) =>
                              setProductBookingData((prev) => ({
                                ...prev,
                                needDrySamagri: e.target.value,
                              }))
                            }
                            className="me-1"
                          />
                          No
                        </label>
                      </div>
                    </div>
                  )}

                </div>

                {/* Price Message Centered */}
                <div className="row">
                  <div className="col-12 d-flex justify-content-center">
                    <div
                      style={{
                        background: "linear-gradient(90deg, #eeb11a, #a52444)",
                        padding: "5px 15px",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        textAlign: "center",
                        color: "white",
                        minWidth: "320px",
                        fontSize: '16px'
                      }}
                    >
                      {productBookingData?.needWetSamagri === "yes" &&
                        productBookingData?.needDrySamagri === "yes" ? (
                        <>
                          Samagri Amount: ₹{" "}
                          {formatToIndianCurrency(
                            (Number(puja?.DrySamagriprice || 0) +
                              Number(puja?.WetSamagriPrice || 0))
                          )}
                        </>
                      ) : productBookingData?.needWetSamagri === "yes" ? (
                        <>
                          Wet Samagri Amount: ₹{" "}
                          {formatToIndianCurrency(puja?.WetSamagriPrice || 0)}
                        </>
                      ) : productBookingData?.needDrySamagri === "yes" ? (
                        <>
                          Dry Samagri Amount: ₹{" "}
                          {formatToIndianCurrency(puja?.DrySamagriprice || 0)}
                        </>
                      ) : (
                        <>All puja samagri will arrange by you  </>
                      )}

                    </div>
                  </div>
                </div>
              </div>
              <div className=" booking-details-right">
                <div className="price-summary">
                  <h5>
                    {puja?.DP_NAME} ({totalDays} Days)
                  </h5>
                  <hr />
                  <ul>
                    <li>
                      <span>
                        {/* Collected on behalf of pandit <br></br> & paid to pandit (₹): */}
                        Puja Price (₹):
                      </span>
                      <span>
                        {/* <br></br> */}

                        {formatToIndianCurrency(
                          Math.round(
                            Number(puja.DP_PRICE) -
                            (Number(puja.DP_PRICE) * Number(puja.DP_DISC)) /
                            100
                          ) * totalDays
                        ) || 0}
                      </span>
                    </li>
                    <hr></hr>
                    {/* <li>
                      <span>Discount ({puja?.DP_DISC}%):</span>
                      <span>
                        - Rs{" "}
                        {formatToIndianCurrency(
                          puja?.DiscountAmount * totalDays
                        ) || 0}
                      </span>
                    </li> */}
                    {(productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "yes")
                      ?
                      (
                        <>
                          {totalDays > 0 && (
                            <>
                              <li>
                                <span>Samagri Price (₹):</span>
                                <span>
                                  {formatToIndianCurrency(((Number(puja?.WetSamagriPrice) +
                                    Number(puja?.WetSamagriPriceTaxAmount)) + (Number(puja?.DrySamagriprice) +
                                      Number(puja?.DrySamagriPriceTaxAmount))) * totalDays)}

                                </span>
                              </li>
                              <hr></hr>
                            </>
                          )}


                        </>
                      )
                      : (productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "no")
                        ?
                        (
                          <>
                            <li>
                              <span> Wet Samagri Price (₹):</span>
                              <span>
                                {formatToIndianCurrency(
                                  (Number(puja?.WetSamagriPrice) +
                                    Number(puja?.WetSamagriPriceTaxAmount)) * totalDays
                                )}

                              </span>
                            </li>
                            <hr></hr>
                          </>
                        ) : (productBookingData?.needWetSamagri === "no" && productBookingData?.needDrySamagri === "yes")
                          ?
                          (
                            <>
                              <li>
                                <span> Dry Samagri Price (₹):</span>
                                <span>
                                  {formatToIndianCurrency(
                                    Number(puja?.DrySamagriprice) +
                                    Number(puja?.DrySamagriPriceTaxAmount)
                                  ) * totalDays}

                                </span>
                              </li>
                              <hr></hr>
                            </>
                          ) : ''
                    }
                    <li>
                      <span>Convenience Fee (₹):</span>
                      <span>
                        {formatToIndianCurrency(
                          Math.round(
                            Number(puja?.CONVENIENCE_FEE) +
                            Number(puja?.ConvinienceFeeTaxAmount)
                          ) * totalDays
                        ) || 0}
                      </span>
                    </li>
                    {/* <li className="">
                      <span>
                        Convenience Tax ({puja?.ConvinienceFeeTaxPercent}%):
                      </span>
                      <span> {formatToIndianCurrency(Math.round(Number(puja?.ConvinienceFeeTaxAmount) * totalDays)) || 0}</span>
                    </li> */}
                    <hr />
                    {/* <li>
                      <span>Total Days:</span>
                      <span>{totalDays} Days</span>
                    </li> */}
                    {/* <li>
                      <span>Tax:</span>
                      <span>Rs {tax}</span>
                    </li> */}

                    <li className="">
                      <span>Grand Total (₹):</span>
                      <span>
                        {" "}
                        {formatToIndianCurrency(Math.round(grandTotal)) || 0}
                      </span>
                    </li>
                  </ul>
                  <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <button
                      onClick={
                        currentStep === 0
                          ? HandleProductBookingBtnClicked
                          : currentStep === 1
                            ? handlePanditSelectionNext
                            : ""
                      }
                      disabled={currentStep === steps.length - 1}
                      className="Normal-app-btn"
                      style={{ padding: "5px 16px", fontSize: "14px" }}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row">
              <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                <label htmlFor="bookingDate" style={{ textAlign: "left" }}>
                  Start Date<span style={{ color: "red" }}>*</span>
                </label>
                <DatePicker
                  id="bookingDate"
                  value={productBookingData?.startDate || ""}
                  minDate={fromDate.toDate()}
                  clearIcon={null}
                  onChange={handleStartDateChange}
                  format="dd/MM/yyyy"
                />
                {error && !productBookingData.startDate && (
                  <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                )}
              </div>
              <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                <label htmlFor="bookingDate" style={{ textAlign: "left" }}>
                  End Date<span style={{ color: "red" }}>*</span>
                </label>
                <DatePicker
                  id="bookingDate"
                  value={productBookingData?.endDate || ""}
                  minDate={
                    productBookingData?.startDate
                      ? new Date(productBookingData.startDate)
                      : fromDate.toDate()
                  }
                  clearIcon={null}
                  onChange={handleEndDateChange}
                  format="dd/MM/yyyy"
                />
                {error && !productBookingData.endDate && (
                  <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                )}
              </div>
              <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                <label htmlFor="bookingTime" style={{ textAlign: "left" }}>
                  Start Time<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="bookingTime"
                  type="time"
                 className="custom-form-control"
                  onClick={(e) => e.target.showPicker && e.target.showPicker()}
                  value={productBookingData.startTime || ""}
                  onChange={(e) =>
                    setProductBookingData((prev) => ({
                      ...prev,
                      startTime: e.target.value,
                    }))
                  }
                />
                {error && !productBookingData.startTime && (
                  <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                )}
              </div>
              <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                <label htmlFor="bookingTime" style={{ textAlign: "left" }}>
                  End Time<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="bookingTime"
                  type="time"
                  onClick={(e) => e.target.showPicker && e.target.showPicker()}
                 className="custom-form-control"
                  value={productBookingData.endTime || ""}
                  onChange={(e) =>
                    setProductBookingData((prev) => ({
                      ...prev,
                      endTime: e.target.value,
                    }))
                  }
                />
                {error && !productBookingData.endTime && (
                  <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                <label htmlFor="language" style={{ textAlign: "left" }}>
                  Select Language<span style={{ color: "red" }}>*</span>
                </label>
                <Select
                styles={customSelectStyles}
                  options={SelectLanguageOptions}
                  onChange={handleLanguageChange}
                  value={SelectLanguageOptions.find(
                    (item) => item.value === productBookingData.languageID
                  )}
                />
                {error && !productBookingData.languageID && (
                  <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                )}
              </div>
              <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                <label htmlFor="landmark" style={{ textAlign: "left" }}>
                  Landmark<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="landmark"
                  type="text"
                 className="custom-form-control"
                  value={productBookingData.landmark || ""}
                  onChange={(e) => {
                    let inputVal = e.target.value.trimStart();
                    setProductBookingData((prev) => ({
                      ...prev,
                      landmark: inputVal,
                    }));
                  }}
                  placeholder="Enter Landmark"
                />
                {error && !productBookingData.landmark && (
                  <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                )}
              </div>
              <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                <label htmlFor="address" style={{ textAlign: "left" }}>
                  Address<span style={{ color: "red" }}>*</span>
                </label>
                <textarea
                  id="address"
                 className="custom-form-control"
                  value={productBookingData.address || ""}
                  onChange={(e) => {
                    let inputVal = e.target.value.trimStart();
                    setProductBookingData((prev) => ({
                      ...prev,
                      address: inputVal,
                    }));
                  }}
                  placeholder="Enter Address"
                />
                {error && !productBookingData.address && (
                  <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                )}
              </div>
              <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                <label htmlFor="state" style={{ textAlign: "left" }}>
                  State<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="state"
                  type="text"
                 className="custom-form-control"
                  value={productBookingData.state || ""}
                  onChange={(e) => {
                    let inputVal = e.target.value.trimStart();
                    setProductBookingData((prev) => ({
                      ...prev,
                      state: inputVal,
                    }));
                  }}
                  placeholder="Enter State"
                />
                {error && !productBookingData.state && (
                  <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                <label htmlFor="City" style={{ textAlign: "left" }}>
                  City
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="City"
                  type="text"
                 className="custom-form-control"
                  value={productBookingData.city || ""}
                  onChange={(e) => {
                    let inputVal = e.target.value;
                    if (inputVal.startsWith(" ")) {
                      inputVal = inputVal.trimStart();
                    }
                    setProductBookingData((prev) => ({
                      ...prev,
                      city: inputVal,
                    }));
                  }}
                  placeholder="Enter City"
                  //   style={{ padding: "0px" }}
                />
                {error &&
                (productBookingData.city === null ||
                  productBookingData.city === undefined ||
                  productBookingData.city === "") ? (
                  <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                <label htmlFor="pincode" style={{ textAlign: "left" }}>
                  Pincode
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="pincode"
                  type="text"
                  maxLength={6}
                 className="custom-form-control"
                  value={productBookingData.pincode || ""}
                  onChange={(e) => {
                    let inputVal = e.target.value;

                    // Remove any non-numeric characters
                    inputVal = inputVal.replace(/\D/g, "");

                    setProductBookingData((prev) => ({
                      ...prev,
                      pincode: inputVal,
                    }));
                  }}
                  placeholder="Enter Pincode"
                  //   style={{ padding: "0px" }}
                />
                {error &&
                (productBookingData.pincode === null ||
                  productBookingData.pincode === undefined ||
                  productBookingData.pincode === "") ? (
                  <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                <label htmlFor="needSamagri" style={{ marginRight: "5px " }}>
                  Do you want Samagri for this Puja?
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div>
                  <label className="me-3">
                    <input
                      type="radio"
                      name="samagri"
                      value="yes"
                      checked={productBookingData.needSamagri === "yes"}
                      onChange={(e) =>
                        setProductBookingData((prev) => ({
                          ...prev,
                          needSamagri: e.target.value,
                        }))
                      }
                      className="me-1"
                    />
                    Yes
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="samagri"
                      value="no"
                      checked={productBookingData.needSamagri === "no"}
                      onChange={(e) =>
                        setProductBookingData((prev) => ({
                          ...prev,
                          needSamagri: e.target.value,
                        }))
                      }
                      className="me-1"
                    />
                    No
                  </label>
                </div>
                {error &&
                (productBookingData.needSamagri === null ||
                  productBookingData.needSamagri === undefined ||
                  productBookingData.needSamagri === "") ? (
                  <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column">
                <span>
                  Your puja samagri amount is: ₹ {puja?.DP_SAMAGRI_PRICE}
                </span>
              </div>
            </div> */}
          </>
        )}

        {/* {currentStep === 1 && (
          <div className="panditList" style={{ width: "100%" }}>
            <div className="container">
              <div className="row mb-4">
                <div className="col-md-12 px-lg-5">

                  <div className="padit-list-products">
                    <div className="row">
                      {panditDataList?.map((pandit) => (
                        <div
                          className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4"
                          key={pandit.PANDIT_ID}
                        >
                          <div
                            className={`card pandit-card ${selectedPandit === pandit.PANDIT_ID
                              ? "selected"
                              : ""
                              }`}
                            onClick={() => handlePanditCardClicked(pandit)}
                          >
                           
                            <div className="card-img-container">
                              <img
                                style={{ padding: "10px", objectFit: "cover" }}
                                src={pandit.PHOTO}
                                onError={(e) => {
                                  e.target.onerror = null; 
                                  e.target.src = placeholderImg; 
                                }}
                                alt={pandit.PANDIT_NAME}
                                className="card-img-top"
                              />
                            </div>

                           
                            <div className="card-body text-center">
                              <h5 className="card-title">
                                {pandit.PANDIT_NAME}
                              </h5>
                              <p className="card-text">
                                <strong>Mobile:</strong> {pandit.MOBILE_NO}
                              </p>
                              <p className="card-text">
                                <strong>Experience:</strong> {pandit.EXPERIENCE}{" "}
                                years
                              </p>
                              <p className="card-text">
                                <strong>DOB:</strong>{" "}
                                {new Date(pandit.DOB).toLocaleDateString()}
                              </p>

                            
                              <div className="rating">
                                {renderStarRating(
                                  parseFloat(pandit.PANDIT_RATING)
                                )}
                                <span className="rating-text">
                                  ({pandit.PANDIT_RATING})
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  {panditSelectionError &&
                    (selectedPandit === null ||
                      selectedPandit === undefined ||
                      selectedPandit === "") ? (
                    <span style={{ color: "red" }}>
                      Please select atleast 1 pandit
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <span className="text-center">
                  {" "}
                  Don't find a pandit of your like?
                  <span
                    onClick={handleFindPandit}
                    style={{ color: "#a42642", cursor: "pointer" }}
                  >
                    {" "}
                    Click here and we will find a pandit for you.
                  </span>
                </span>
              </div>
            </div>
          </div>
        )} */}

        {currentStep === 1 && (
          <div className="py-4" style={{ width: "100%" }}>
            <div className="p-3">
              <div className="row g-4 d-flex">
                <div
                  className="booking-preview col-md-5 text-center"
                  style={{
                    flex: "2",
                  }}
                >
                  <div className="booking-preview-details-puja">
                    <div className="booking-preview-details-puja-top">
                      <div className="booking-preview-details-puja-top-left">
                        <img
                          src={puja.DP_IMAGE}
                          alt=""
                          onError={(e) => {
                            e.target.onerror = null; // Prevent infinite loop
                            e.target.src = placeholderImg; // Set fallback image
                          }}
                        />
                      </div>
                      <div className="booking-preview-details-puja-top-right">
                        <span className="puja-name">{puja.DP_NAME}</span>
                        <span>
                          Puja Language:{" "}
                          {
                            languageOption.filter(
                              (item) =>
                                item.value === productBookingData.languageID
                            )[0]?.label
                          }
                        </span>
                        <span>
                          Puja Start Date: {productBookingData.startDate}
                        </span>
                        <span>Puja End Date: {productBookingData.endDate}</span>

                        <span>
                          Puja Time: {formatTime(productBookingData.startTime)}{" "}
                          to {formatTime(productBookingData.endTime)}
                        </span>

                        {/* <span>
                          Pandit Name:{" "}
                          {
                            panditDataList.filter(
                              (item) => item.PANDIT_ID === selectedPandit
                            )[0]?.PANDIT_NAME
                          }
                        </span> */}
                      </div>
                    </div>
                    <p className="fw-bold">
                      Note : You will receive pandit details within 24 hours
                    </p>
                  </div>
                </div>
                <div className=" booking-details-right">
                  <div className="price-summary">
                    <h5>
                      {puja?.DP_NAME} ({totalDays} Days)
                    </h5>
                    <hr />
                    <ul>
                      <li>
                        {appliedCoupon?.isApplied ? (
                          <div

                            style={{
                              backgroundColor: 'rgb(239 178 29)',
                              borderRadius: '10px',
                              padding: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div onClick={() => handleOpenCoupenModal()} style={{ display: 'flex', alignItems: 'center' }}>

                              <span>Applied Coupon</span>
                              {appliedCoupon && (
                                <>
                                  <span
                                    style={{
                                      border: '1px dotted #333',
                                      padding: '2px 6px',
                                      borderRadius: '4px',
                                      fontSize: '12px',
                                      backgroundColor: '#fff',
                                      color: '#333',
                                      marginLeft: '6px',
                                    }}
                                  >
                                    {appliedCoupon?.CouponCode}
                                  </span>

                                </>


                              )}
                            </div>
                            <span
                              onClick={() => {
                                setAppliedCoupon((prev) => ({
                                  ...prev, CouponCode: null,
                                  isApplied: false,
                                  CoupenAmount: 0,
                                  walletAmount: 0
                                }))
                              }}
                              style={{
                                // border: '1px dotted #333',
                                padding: '2px 6px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                backgroundColor: '#fff',
                                color: '#a52444',
                                marginLeft: '6px',
                              }} >



                              Remove

                            </span>
                            <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                          </div>
                        ) : (
                          <div
                            onClick={() => setShowModal(true)}
                            style={{
                              backgroundColor: 'rgb(239 178 29)',
                              borderRadius: '10px',
                              padding: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div style={{
                                backgroundColor: '#a52444',
                                color: 'white',
                                borderRadius: '50%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                marginRight: '10px',

                              }}>
                                %
                              </div>
                              <span style={{ fontWeight: '400' }}>View Coupons & Offers</span>

                            </div>
                            <span style={{ fontSize: '20px', fontWeight: 'bolder' }}>›</span>
                          </div>
                        )}

                      </li>
                      {walletAmount !== 0 && (
                        <li style={{ fontSize: 'smaller', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div

                            style={{
                              backgroundColor: 'rgb(239 178 29)',
                              borderRadius: '10px',
                              padding: '10px',
                              // display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              // cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>

                              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', width: '100%' }}>
                                <input
                                  type="checkbox"
                                  checked={isWalletApplied}
                                  onChange={(e) => {
                                    setAppliedCoupon((PREV) => ({
                                      ...PREV, CouponCode: null,
                                      isApplied: false
                                    }))
                                    setIsWalletApplied(e.target.checked)
                                  }
                                  }

                                  style={{ cursor: 'pointer' }}
                                />

                                Available wallet amount (₹) {walletAmount}

                              </label>
                            </div>
                            {/* <div className="d-flex justify-content-center">

                              <small>(Upto 50% can be applied)</small>
                            </div> */}
                            {/* <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span> */}
                          </div>

                        </li>
                      )}


                      <hr></hr>
                      <li>
                        <span>
                          {/* Collected on behalf of pandit <br></br> & paid to pandit (₹): */}
                          Puja Price (₹):
                        </span>
                        <span>
                          {/* <br></br> */}

                          {formatToIndianCurrency(
                            Math.round(
                              Number(puja.DP_PRICE) -
                              (Number(puja.DP_PRICE) * Number(puja.DP_DISC)) /
                              100
                            ) * totalDays
                          ) || 0}
                        </span>
                      </li>
                      {isWalletApplied && appliedCoupon?.isApplied === false ? (
                        <li style={{ fontSize: 'smaller' }}>
                          <span>
                            Applied Wallet Amount (₹)

                          </span>
                          <span>
                            {appliedCoupon?.walletAmount}
                          </span>
                        </li>
                      ) : isWalletApplied === false && appliedCoupon?.isApplied ? (
                        <li style={{ fontSize: 'smaller' }}>
                          <span>
                            Applied Coupon  Amount (₹)

                          </span>
                          <span>
                            {couponAmount}
                          </span>
                        </li>
                      ) : ''}
                      <hr></hr>
                      {(productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "yes")
                        ?
                        (
                          <>
                            <li>
                              <span>Samagri Price (₹):</span>
                              <span>
                                {formatToIndianCurrency((Number(puja?.WetSamagriPrice) +
                                  Number(puja?.WetSamagriPriceTaxAmount)) + (Number(puja?.DrySamagriprice) +
                                    Number(puja?.DrySamagriPriceTaxAmount)) * totalDays)}

                              </span>
                            </li>
                            <hr></hr>
                          </>
                        )
                        : (productBookingData?.needWetSamagri === "yes" && productBookingData?.needDrySamagri === "no")
                          ?
                          (
                            <>
                              <li>
                                <span> Wet Samagri Price (₹):</span>
                                <span>
                                  {formatToIndianCurrency(
                                    (Number(puja?.WetSamagriPrice) +
                                      Number(puja?.WetSamagriPriceTaxAmount)) * totalDays
                                  )}

                                </span>
                              </li>
                              <hr></hr>
                            </>
                          ) : (productBookingData?.needWetSamagri === "no" && productBookingData?.needDrySamagri === "yes")
                            ?
                            (
                              <>
                                <li>
                                  <span> Dry Samagri Price (₹):</span>
                                  <span>
                                    {formatToIndianCurrency(
                                      Number(puja?.DrySamagriprice) +
                                      Number(puja?.DrySamagriPriceTaxAmount)
                                    ) * totalDays}

                                  </span>
                                </li>
                                <hr></hr>
                              </>
                            ) : ''
                      }

                      {/* <li>
                      <span>Discount ({puja?.DP_DISC}%):</span>
                      <span>
                        - Rs{" "}
                        {formatToIndianCurrency(
                          puja?.DiscountAmount * totalDays
                        ) || 0}
                      </span>
                    </li> */}

                      <li>
                        <span>Convenience Fee (₹):</span>
                        <span>
                          {formatToIndianCurrency(
                            Math.round(
                              Number(puja?.CONVENIENCE_FEE) +
                              Number(puja?.ConvinienceFeeTaxAmount)
                            ) * totalDays
                          ) || 0}
                        </span>
                      </li>
                      {/* <li className="">
                      <span>
                        Convenience Tax ({puja?.ConvinienceFeeTaxPercent}%):
                      </span>
                      <span> {formatToIndianCurrency(Math.round(Number(puja?.ConvinienceFeeTaxAmount) * totalDays)) || 0}</span>
                    </li> */}
                      <hr />
                      {/* <li>
                      <span>Total Days:</span>
                      <span>{totalDays} Days</span>
                    </li> */}
                      {/* <li>
                      <span>Tax:</span>
                      <span>Rs {tax}</span>
                    </li> */}

                      <li className="">
                        <span>Grand Total (₹):</span>
                        <span>
                          {" "}
                          {formatToIndianCurrency(Math.round(grandTotal)) || 0}
                        </span>
                      </li>
                    </ul>
                    <div className="mt-3 d-flex justify-content-end gap-2">
                      <button
                        style={{ padding: "5px 16px", fontSize: "14px" }}
                        className="Normal-app-btn"
                        onClick={handleCODClicked}
                      >
                        Cash On Delivery
                      </button>
                      {/* <button
                        style={{ padding: "5px 16px", fontSize: "14px" }}
                        className="Normal-app-btn"
                        onClick={handlePhonePayCODClicked}
                      >
                        PhonePay On Cod
                      </button> */}
                      <button
                        style={{ padding: "5px 16px", fontSize: "14px" }}
                        className="Normal-app-btn"
                        onClick={handleRazorpayPayment}
                      >
                        Pay
                      </button>
                      {/* <button
                        style={{ padding: "5px 16px", fontSize: "14px" }}
                        className="Normal-app-btn"
                        onClick={handlePhonepayPayment}
                      >
                        Phone Pay
                      </button> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div>
            <div className="carousel-inner" role="listbox">
              <div className="item carousel-item-four active">
                <div className="">
                  <div className="row">
                    <div className="carousel slide carousel-slider">
                      <div className="carousel-position-four">
                        <div className="carousel-inner">
                          <div
                            className="banner-breadcrumb"
                            style={{
                              // backgroundImage: `url(${StupaImg})`,
                              width: "100%",
                              // height: "100px",
                            }}

                          // style={{ backgroundImage: `url(${AboutImg})` }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="error-404">
              <div>
                <img
                  src={placeholderImg}
                  alt="404"
                  className="error-404__image"
                />
              </div>

              <h3 className="error-404__text">Thank you for your order! </h3>
              <div className="error-404__btns"></div>
            </div>
          </div>
        )}
      </div>

      {/* Navigation Buttons */}
      {currentStep === 0 ? (
        <div
          className="navigation-buttons"
          style={{ marginRight: "50px", paddingBottom: "30px" }}
        >
          {/* <button
            className="btn btn-secondry"
            style={{ backgroundColor: "#d7d7d7", color: "black" }}
            onClick={prevStep}
          >
            Previous
          </button> */}
          {/* <button
            onClick={
              currentStep === 0
                ? HandleProductBookingBtnClicked
                : currentStep === 1
                  ? handlePanditSelectionNext
                  : ""
            }
            disabled={currentStep === steps.length - 1}
            className="Normal-app-btn"
            style={{ padding: "5px 16px", fontSize: "14px" }}
          >
            Next
          </button> */}
        </div>
      ) : currentStep === 1 ? (
        <div
          className="navigation-buttons"
          style={{ marginRight: "50px", paddingBottom: "30px" }}
        >
          <button
            className="Normal-app-btn"
            style={{ padding: "5px 14px", fontSize: "14px" }}
            onClick={prevStep}
          >
            Previous
          </button>
        </div>
      ) : currentStep === 2 ? (
        <div
          className="navigation-buttons"
          style={{ marginRight: "50px", paddingBottom: "30px" }}
        >
          <button
            className="Normal-app-btn"
            style={{ padding: "5px 16px", fontSize: "14px" }}
            onClick={() => navigate("/")}
          >
            Home
          </button>
          <button
            className="Normal-app-btn"
            style={{ padding: "5px 16px", fontSize: "14px" }}
            onClick={() => navigate("/my-order-daily-Booking")}
          >
            My Orders
          </button>
        </div>
      ) : (
        currentStep === 1 && (
          <div
            className="navigation-buttons"
            style={{ marginRight: "50px", paddingBottom: "30px" }}
          >
            <button
              onClick={prevStep}
              disabled={currentStep === 0}
              className="Normal-app-btn"
              style={{ padding: "5px 16px", fontSize: "14px" }}
            >
              Previous
            </button>
            <button
              onClick={
                currentStep === 0
                  ? HandleProductBookingBtnClicked
                  : currentStep === 1
                    ? handlePanditSelectionNext
                    : ""
              }
              disabled={currentStep === steps.length - 1}
              className="Normal-app-btn"
              style={{ padding: "5px 16px", fontSize: "14px" }}
            >
              Next
            </button>
          </div>
        )
      )}
      <CODModalDailyBooking
        show={showCODModal}
        onHide={() => setShowCODModal(false)}
        onConfirm={handleRazorpayPayment}
        modelRequestData={modelRequestData}
        setModelRequestData={setModelRequestData}
      />
      <PhonePayCODModalDailyBooking
        show={showPhonePayCODModal}
        onHide={() => setShowPhonePayCODModal(false)}
        onConfirm={handlePhonepayPayment}
        modelRequestData={modelRequestData}
        setModelRequestData={setModelRequestData}
      />
      <CouponModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        modelRequestData={modelRequestData}
        setAppliedCoupon={setAppliedCoupon}
        setIsWalletApplied={setIsWalletApplied}
        apiParam={couponObj} />
    </div>
  );
};

export default DailyPujaBooking;
